import QRCode from 'qrcode';

export const generateQRCode = async (canvasRef, inputString) => {
    try {
      await QRCode.toCanvas(canvasRef.current, inputString, { errorCorrectionLevel: 'H' });
    } catch (error) {
      console.error('Failed to generate QR code:', error);
    }
  };


// WEBPACK FOOTER //
// ./src/utils/qr.js